<template>
    <LineChartGenerator
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="height"
    />
  </template>

<script>
import { Line as LineChartGenerator } from 'vue-chartjs/legacy'

import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement
} from 'chart.js'

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement
)

const highlightTodayPlugin = {
    id: 'highlightToday',
    afterDraw(chart) {
        const { ctx, chartArea: { top, bottom }, scales } = chart
        const today = new Date()
        const todayLabel = `${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`

        const labelIndex = chart.data.labels.findIndex(label => label === todayLabel)

        if (labelIndex === -1) return

        const x = scales.x.getPixelForValue(labelIndex)

        ctx.save()
        ctx.beginPath()
        ctx.setLineDash([5, 5])
        ctx.moveTo(x, top)
        ctx.lineTo(x, bottom)
        ctx.lineWidth = 2
        ctx.strokeStyle = 'rgba(255, 99, 132, 0.8)' // a reddish line
        ctx.stroke()
        ctx.restore()
    }
}

export default {
    name: 'LineChart',
    components: {
        LineChartGenerator
    },
    props: {
        alertData: {
            type: Object,
            default: () => {}
        },
        chartId: {
            type: String,
            default: 'line-chart'
        },
        datasetIdKey: {
            type: String,
            default: 'label'
        },
        width: {
            type: Number,
            default: 400
        },
        height: {
            type: Number,
            default: 400
        },
        cssClasses: {
            default: '',
            type: String
        },
        styles: {
            type: Object,
            default: () => {}
        },
        plugins: {
            type: Array,
            default: () => [highlightTodayPlugin]
        }
    },
    data() {
        return {
            chartData: {
                labels: [],
                datasets: [
                    {
                        label: 'Poziom zagrożenia',
                        backgroundColor: '#f87979',
                        data: []
                    }
                ]
            },

            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                clip: false,
                plugins: {
                    title: {
                        display: true,
                        text: 'Prognoza poziomu zagrożenia',
                        font: {
                            size: 18
                        }
                    }
                },
                scales: {
                    y: {
                        min: 0,
                        max: 5,
                        ticks: {
                            stepSize: 1

                        }
                    }
                }
            }

        }
    },
    computed: {
        alert() {
            return this.$store.getters.alert
        }
    },
    async created() {
        let prediction
        try {
            prediction = await this.$store.dispatch('fetchAlertPrediction', {
                region: this.alert.countie,
                crop: this.alert.crops[0].name_en,
                disease: this.alert.agrofags[0].name_en
            })
        } catch (error) {
            console.error(error)
            return error
        }
        const resultData = prediction.data.data.data[0]
        const dataPerDay = resultData.field_group_forecasts[0].diseases[0].risk_by_date

        this.chartData.datasets[0].data = dataPerDay.map(item => item.risk_level)
        this.chartData.labels = dataPerDay.map(item => item.date.replace(`${new Date().getFullYear()}-`, ''))
    },
    mounted() {

    }
}
</script>
